import { Children, cloneElement, useEffect } from 'react';

import { useDuplicateCheckQuery } from '../../Common/Queries/applicationsQueries';
import { usePositionsGetQuery } from '../../Common/Queries/positionsQueries';
import { useAddReferralQuery } from '../../Common/Queries/referralsQueries';

import { isLogin } from '../../utils';

import { ALL_DATA_LIMIT, DURATION_TIME } from '../../constants';

/**
 * @function formateData
 * @param values
 * @returns formated values
 */
export const formateData = (state) => {
  return {
    name: state.name,
    phone: `+91${state.phone}`,
    email: state.email,
    position: state.position,
    referrerRelation: state.relationship,
    customFormData: state?.customFormData,
  };
};

export const duplicateData = (state) => {
  return {
    phone: `+91${state.phone}`,
    email: state.email,
    position: state.position,
    isReferral: state.isReferral,
  };
};

export function AddReferralContainer({ setOpen, children, initialPosition, setTitle }) {
  const positionList = usePositionsGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  const postToReferral = useAddReferralQuery();

  const postDuplicateCheck = useDuplicateCheckQuery();

  function handleSubmitForAddReferral(values, noticeValue) {
    const reqBody = formateData(values, noticeValue);
    postToReferral.mutate(reqBody);
  }

  function handleDuplicateCheck(values) {
    const reqBody = duplicateData(values);
    postDuplicateCheck.mutate(reqBody);
  }

  useEffect(() => {
    if (postToReferral.isSuccess) {
      setOpen(false);
    }
  }, [postToReferral.isSuccess]);

  return Children.only(
    cloneElement(children, {
      postToReferral,
      handleSubmitForAddReferral,
      handleDuplicateCheck,
      postDuplicateCheck,
      positionList,
      initialPosition,
      setTitle,
    })
  );
}
